<template>
  <div>
    <div class="marTML pf23-subTit">
      <div class="widM fntH4 bold padTS padBS" style="color:#fff;">액티비티 예약</div>
    </div>

    <div class="osResTbScrollWrap marTML NCAcmi_table widM">
      <div class="osResTbScroll osResTbBlock">
        <table class="osResTb05 txtC">
          <caption>
            액티비티 예약 날짜별 시간 일정 안내
          </caption>
          <colgroup>
            <col style="width:13%;">
            <col style="width:13%">
            <col style="width:auto;">
            <col style="width:auto;">
            <col style="width:13%;">
          </colgroup>
          <thead>
            <tr>
              <th scope="col">Day 1</th>
              <th scope="col">Day 2</th>
              <th scope="col">Day 3</th>
              <th scope="col">Day 4</th>
              <th scope="col">Day 5</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td rowspan="3">체크인</td>
              <td rowspan="2">워크샵</td>
              <td>체크아웃 (3일차 복귀 인원) 및 <br>선택 프로그램 진행</td>
              <td rowspan="3">체크아웃 (4일차 복귀 인원) 및 <br>자유 일정</td>
              <td rowspan="3">체크아웃 및 <br>자유 일정</td>
            </tr>
            <tr>
              <td>
                1. 유니버셜 스튜디오<br>
                2. 오감만족 싱가로프 핫스팟 투어<br>
                3. 호텔 휴식
              </td>
            </tr>
            <tr>
              <td>갈라 디너</td> 
              <td>외부 석식</td> 
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="widM txtC marTML">
      <a @click="openActivityPopup" class="disIb fntH5 bold pf23-activeBtn" >
        액티비티 정보 안내 &nbsp;
        <img src="@/views/survey2/images/NCAcmi_arrow.png" alt="" class="verM" style="max-width:10px; width:2%;">
      </a>
      <p class="fntE txtL marTSM" style="color:#d91734;">* 액티비티 별 잔여인원은 제출 시간에 따라 차이가 있을 수 있습니다.</p>
    </div>

    <!-- <hr style="border-top:1px solid #ddd; background:#f4f4f4; padding:5px 0;">-->

    <template v-for="(activity, sq_code, i) in activities">
      <SurveyActivityParticipant
        :key="`activity_${sq_code}`"
        :activity="activity"
        :is-first="i === 0"
      />
      <!-- <hr
        v-if="i < activityCount - 1"
        :key="`hr_${activity.sq_code}`"
        style="border-top:1px solid #ddd; background:#f4f4f4; padding:5px 0;"> -->
    </template>
  </div>
</template>

<script>
import { CommonMethodMixin } from '../mixins'
import { SURVEY_SINGAPORE, ACTIVITY_QUESTIONS, TOGGLE_ACTIVITY_POPUP } from '@/store/actions/survey'
import { mapGetters } from 'vuex'
import SurveyActivityParticipant from './SurveyActivityParticipant.vue'

export default {
  name: 'SurveyActivityList',
  mixins: [CommonMethodMixin],
  components: {
    SurveyActivityParticipant,
  },
  computed: {
    ...mapGetters(SURVEY_SINGAPORE, {
      activities: ACTIVITY_QUESTIONS,
    }),
    activityCount() {
      return Object.keys(this.activities).length;
    }
  },
  methods: {
    openActivityPopup() {
      this.$store.commit(`${SURVEY_SINGAPORE}/${TOGGLE_ACTIVITY_POPUP}`, true);
    }
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/surveys/singapore/components/SurveyActivityList.vue